import { Box, styled } from "@mui/material";

export const TileHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "13px 0px 18px 6px",
  boxSizing: "border-box",
}));
